export const PERMISSIONS = {
  userManage: 'user_manage',
  contractManage: 'contract_manage',
  contractView: 'contract_view'
};
